module.exports = __webpack_public_path__ + "static/media/tea-talk.5b17c43c.png";